import {RiExternalLinkFill} from 'react-icons/ri'
import './componentStyle.css'
import { useTranslation } from "react-i18next";

const InseeExternalLink=()=>{
    const { t } = useTranslation();
    const style = { color: "#264c7a", marginRight:'10px'}
    return (<a href='https://www.insee.fr/fr/accueil' className='button-icon' target="_blank" rel="noreferrer noopener">
            <RiExternalLinkFill style={style}/>{t('footer_external_link')}</a>)
}

export default InseeExternalLink;